module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fipxU"))).then(() => parcelRequire('37nVf'));